import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AccessDenied from './AccessDenied';

const RequireAuth = ({ children, roles = [], permissions = [] }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-slate-200 border-t-slate-600 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-sm text-slate-500">Authentifizierung wird geprüft…</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin" state={{ from: location }} replace />;
  }

  const normalizeRole = (role) => {
    if (!role) return '';
    return role.toLowerCase().replace(/[-_]/g, '');
  };

  // Prüfe Permissions
  if (permissions.length > 0) {
    const userRole = normalizeRole(user?.role);
    const isSuperAdmin = userRole === 'superadmin';
    
    if (!isSuperAdmin) {
      const userPermissions = Array.isArray(user?.permissions) ? user.permissions : [];
      const hasPermission = permissions.some((permission) =>
        userPermissions.includes(permission)
      );

      if (!hasPermission) {
        return <AccessDenied />;
      }
    }
  }

  // Prüfe Rollen
  if (roles.length > 0) {
    const normalizedRoles = roles.map((role) => normalizeRole(role));
    const userRole = normalizeRole(user?.role);

    const hasRoleAccess =
      normalizedRoles.includes(userRole) ||
      userRole === 'superadmin';

    if (!hasRoleAccess) {
      return <AccessDenied />;
    }
  }

  return children;
};

export default RequireAuth;

